<template>
  <div>{{ msg1 }}</div>
</template>

<script>
export default {
  name: "Solution",
  props: {
    msg: String,
  },
  data() {
    return {
      msg1: "",
    };
  },
  mounted: function () {
    this.msg1 = "originalScript";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
